import * as XLSX from 'xlsx';

// ==========================================
// 1. FOOD DATABASE (ORAL & ENTERAL) HELPERS
// ==========================================

export const FOOD_EXCEL_COLUMNS = [
  { key: 'name', label: 'Nama Makanan / Minuman *' },
  { key: 'unit', label: 'Satuan Porsi *' },
  { key: 'energy_kcal', label: 'Energi (Kcal) *' },
  { key: 'protein_g', label: 'Protein (g) *' },
  { key: 'carbohydrate_g', label: 'Karbohidrat (g) *' },
  { key: 'fat_g', label: 'Lemak (g) *' },
  { key: 'fiber_g', label: 'Serat (g)' },
  // Elektrolit
  { key: 'sodium_mg', label: 'Natrium (mg)' },
  { key: 'potassium_mg', label: 'Kalium (mg)' },
  { key: 'chloride_mg', label: 'Klorida (mg)' },
  // Asam Lemak
  { key: 'omega3_mg', label: 'Omega 3 (mg)' },
  { key: 'omega6_mg', label: 'Omega 6 (mg)' },
  // Vitamin
  { key: 'vitamin_a_mcg', label: 'Vitamin A (mcg)' },
  { key: 'vitamin_d3_mcg', label: 'Vitamin D3 (mcg)' },
  { key: 'vitamin_e_mcg', label: 'Vitamin E (mcg)' },
  { key: 'vitamin_k_mcg', label: 'Vitamin K (mcg)' },
  { key: 'vitamin_b1_mg', label: 'Vitamin B1 (mg)' },
  { key: 'vitamin_b2_mg', label: 'Vitamin B2 (mg)' },
  { key: 'vitamin_b3_mg', label: 'Vitamin B3 (mg)' },
  { key: 'vitamin_b5_mg', label: 'Vitamin B5 (mg)' },
  { key: 'vitamin_b6_mg', label: 'Vitamin B6 (mg)' },
  { key: 'vitamin_b12_mcg', label: 'Vitamin B12 (mcg)' },
  { key: 'folic_acid_mcg', label: 'Asam Folat (mcg)' },
  { key: 'biotin_mcg', label: 'Biotin (mcg)' },
  { key: 'choline_mg', label: 'Kolin (mg)' },
  { key: 'vitamin_c_mg', label: 'Vitamin C (mg)' },
  // Mineral
  { key: 'calcium_mg', label: 'Kalsium (mg)' },
  { key: 'phosphorus_mg', label: 'Fosfor (mg)' },
  { key: 'magnesium_mg', label: 'Magnesium (mg)' },
  { key: 'iron_mg', label: 'Besi / Fe (mg)' },
  { key: 'iodine_mcg', label: 'Iodium (mcg)' },
  { key: 'zinc_mg', label: 'Seng / Zn (mg)' },
  { key: 'selenium_mcg', label: 'Selenium (mcg)' },
  { key: 'manganese_mg', label: 'Mangan (mg)' },
  { key: 'fluoride_mg', label: 'Fluorida (mg)' },
  { key: 'chromium_mcg', label: 'Kromium (mcg)' },
  { key: 'copper_mg', label: 'Tembaga / Cu (mg)' }
];

/**
 * Export all foods to Excel
 */
export const exportFoodsToExcel = (foods, filename = 'NUTRIMUS_Database_Makanan.xlsx') => {
  const headers = FOOD_EXCEL_COLUMNS.map(c => c.label);
  
  const rows = foods.map(food => {
    const macro = food.macronutrients || {};
    const electro = food.electrolytes || {};
    const fatty = food.fatty_acids || {};
    const vit = food.vitamins || {};
    const min = food.minerals || {};

    return [
      food.name || '',
      food.unit || '100g',
      macro.energy_kcal !== undefined ? Math.round(macro.energy_kcal) : 0,
      macro.protein_g !== undefined ? Number(macro.protein_g) : 0,
      macro.carbohydrate_g !== undefined ? Number(macro.carbohydrate_g) : 0,
      macro.fat_g !== undefined ? Number(macro.fat_g) : 0,
      macro.fiber_g !== undefined ? Number(macro.fiber_g) : 0,
      electro.sodium_mg !== undefined ? Number(electro.sodium_mg) : 0,
      electro.potassium_mg !== undefined ? Number(electro.potassium_mg) : 0,
      electro.chloride_mg !== undefined ? Number(electro.chloride_mg) : 0,
      fatty.omega3_mg !== undefined ? Number(fatty.omega3_mg) : 0,
      fatty.omega6_mg !== undefined ? Number(fatty.omega6_mg) : 0,
      vit.vitamin_a_mcg !== undefined ? Number(vit.vitamin_a_mcg) : 0,
      vit.vitamin_d3_mcg !== undefined ? Number(vit.vitamin_d3_mcg) : 0,
      vit.vitamin_e_mcg !== undefined ? Number(vit.vitamin_e_mcg) : 0,
      vit.vitamin_k_mcg !== undefined ? Number(vit.vitamin_k_mcg) : 0,
      vit.vitamin_b1_mg !== undefined ? Number(vit.vitamin_b1_mg) : 0,
      vit.vitamin_b2_mg !== undefined ? Number(vit.vitamin_b2_mg) : 0,
      vit.vitamin_b3_mg !== undefined ? Number(vit.vitamin_b3_mg) : 0,
      vit.vitamin_b5_mg !== undefined ? Number(vit.vitamin_b5_mg) : 0,
      vit.vitamin_b6_mg !== undefined ? Number(vit.vitamin_b6_mg) : 0,
      vit.vitamin_b12_mcg !== undefined ? Number(vit.vitamin_b12_mcg) : 0,
      vit.folic_acid_mcg !== undefined ? Number(vit.folic_acid_mcg) : 0,
      vit.biotin_mcg !== undefined ? Number(vit.biotin_mcg) : 0,
      vit.choline_mg !== undefined ? Number(vit.choline_mg) : 0,
      vit.vitamin_c_mg !== undefined ? Number(vit.vitamin_c_mg) : 0,
      min.calcium_mg !== undefined ? Number(min.calcium_mg) : 0,
      min.phosphorus_mg !== undefined ? Number(min.phosphorus_mg) : 0,
      min.magnesium_mg !== undefined ? Number(min.magnesium_mg) : 0,
      min.iron_mg !== undefined ? Number(min.iron_mg) : 0,
      min.iodine_mcg !== undefined ? Number(min.iodine_mcg) : 0,
      min.zinc_mg !== undefined ? Number(min.zinc_mg) : 0,
      min.selenium_mcg !== undefined ? Number(min.selenium_mcg) : 0,
      min.manganese_mg !== undefined ? Number(min.manganese_mg) : 0,
      min.fluoride_mg !== undefined ? Number(min.fluoride_mg) : 0,
      min.chromium_mcg !== undefined ? Number(min.chromium_mcg) : 0,
      min.copper_mg !== undefined ? Number(min.copper_mg) : 0
    ];
  });

  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Database Makanan');
  XLSX.writeFile(wb, filename);
};

/**
 * Generate and download Food Template Excel
 */
export const downloadFoodTemplateExcel = () => {
  const headers = FOOD_EXCEL_COLUMNS.map(c => c.label);
  
  // Sample guidance rows
  const sampleRows = [
    [
      'Nasi Putih Matang', '100g', 130, 2.7, 28.2, 0.3, 0.4,
      1, 35, 0, 0, 0, 0, 0, 0, 0, 0.07, 0.01, 1.6, 0.4, 0.09, 0, 3, 0, 5.8, 0,
      10, 43, 12, 0.2, 0, 0.5, 7.5, 0.5, 0, 0, 0.07
    ],
    [
      'Peptisol Sachet 63g', '1 sachet', 250, 14.0, 43.0, 3.0, 0.0,
      120, 230, 100, 100, 300, 150, 2.5, 3.5, 10, 0.4, 0.5, 5.0, 2.0, 0.6, 1.2, 100, 15, 50, 30,
      250, 200, 75, 4.5, 35, 4.0, 15, 0.5, 0.2, 10, 0.3
    ]
  ];

  const ws = XLSX.utils.aoa_to_sheet([headers, ...sampleRows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Template Makanan');
  XLSX.writeFile(wb, 'NUTRIMUS_Template_Import_Makanan.xlsx');
};

/**
 * Parse uploaded Food Excel file into backend FoodItemCreate payload
 */
export const parseFoodExcel = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rawRows = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });

        if (!rawRows || rawRows.length < 2) {
          throw new Error('File Excel kosong atau tidak memiliki baris data.');
        }

        const headerRow = rawRows[0].map(h => String(h).trim().toLowerCase());
        
        // Find column index helper by keyword
        const findColIdx = (keywords) => {
          return headerRow.findIndex(h => keywords.some(k => h.includes(k.toLowerCase())));
        };

        const nameIdx = findColIdx(['nama makanan', 'nama', 'name']);
        const unitIdx = findColIdx(['satuan porsi', 'satuan', 'unit']);
        const energyIdx = findColIdx(['energi', 'energy', 'kcal']);
        const proteinIdx = findColIdx(['protein']);
        const carbsIdx = findColIdx(['karbohidrat', 'karbo', 'carbs', 'kh']);
        const fatIdx = findColIdx(['lemak', 'fat']);
        const fiberIdx = findColIdx(['serat', 'fiber']);

        if (nameIdx === -1 || energyIdx === -1) {
          throw new Error('Kolom wajib "Nama Makanan" dan "Energi (Kcal)" tidak ditemukan di header Excel.');
        }

        // Helper to get number
        const getNum = (row, idx) => {
          if (idx === -1 || row[idx] === undefined || row[idx] === '') return 0;
          const val = Number(String(row[idx]).replace(',', '.').trim());
          return isNaN(val) ? 0 : val;
        };

        const parsedFoods = [];
        const errors = [];

        for (let i = 1; i < rawRows.length; i++) {
          const row = rawRows[i];
          const name = String(row[nameIdx] || '').trim();
          if (!name) continue; // Skip blank rows

          const unit = unitIdx !== -1 && row[unitIdx] ? String(row[unitIdx]).trim() : '100g';
          const energy = getNum(row, energyIdx);
          const protein = getNum(row, proteinIdx);
          const carbs = getNum(row, carbsIdx);
          const fat = getNum(row, fatIdx);
          const fiber = getNum(row, fiberIdx);

          parsedFoods.push({
            name,
            unit,
            macronutrients: {
              energy_kcal: Math.round(energy),
              protein_g: Number(protein.toFixed(2)),
              carbohydrate_g: Number(carbs.toFixed(2)),
              fat_g: Number(fat.toFixed(2)),
              fiber_g: Number(fiber.toFixed(2))
            },
            electrolytes: {
              sodium_mg: getNum(row, findColIdx(['natrium', 'sodium'])),
              potassium_mg: getNum(row, findColIdx(['kalium', 'potassium'])),
              chloride_mg: getNum(row, findColIdx(['klorida', 'chloride']))
            },
            fatty_acids: {
              omega3_mg: getNum(row, findColIdx(['omega 3', 'omega3'])),
              omega6_mg: getNum(row, findColIdx(['omega 6', 'omega6']))
            },
            vitamins: {
              vitamin_a_mcg: getNum(row, findColIdx(['vitamin a', 'vit a'])),
              vitamin_d3_mcg: getNum(row, findColIdx(['vitamin d', 'vit d'])),
              vitamin_e_mcg: getNum(row, findColIdx(['vitamin e', 'vit e'])),
              vitamin_k_mcg: getNum(row, findColIdx(['vitamin k', 'vit k'])),
              vitamin_b1_mg: getNum(row, findColIdx(['vitamin b1', 'vit b1'])),
              vitamin_b2_mg: getNum(row, findColIdx(['vitamin b2', 'vit b2'])),
              vitamin_b3_mg: getNum(row, findColIdx(['vitamin b3', 'vit b3'])),
              vitamin_b5_mg: getNum(row, findColIdx(['vitamin b5', 'vit b5'])),
              vitamin_b6_mg: getNum(row, findColIdx(['vitamin b6', 'vit b6'])),
              vitamin_b12_mcg: getNum(row, findColIdx(['vitamin b12', 'vit b12'])),
              folic_acid_mcg: getNum(row, findColIdx(['folat', 'folic'])),
              biotin_mcg: getNum(row, findColIdx(['biotin'])),
              choline_mg: getNum(row, findColIdx(['kolin', 'choline'])),
              vitamin_c_mg: getNum(row, findColIdx(['vitamin c', 'vit c']))
            },
            minerals: {
              calcium_mg: getNum(row, findColIdx(['kalsium', 'calcium'])),
              phosphorus_mg: getNum(row, findColIdx(['fosfor', 'phosphorus'])),
              magnesium_mg: getNum(row, findColIdx(['magnesium'])),
              iron_mg: getNum(row, findColIdx(['besi', 'iron', 'fe'])),
              iodine_mcg: getNum(row, findColIdx(['iodium', 'iodine'])),
              zinc_mg: getNum(row, findColIdx(['seng', 'zinc', 'zn'])),
              selenium_mcg: getNum(row, findColIdx(['selenium'])),
              manganese_mg: getNum(row, findColIdx(['mangan', 'manganese'])),
              fluoride_mg: getNum(row, findColIdx(['fluorida', 'fluoride'])),
              chromium_mcg: getNum(row, findColIdx(['kromium', 'chromium'])),
              copper_mg: getNum(row, findColIdx(['tembaga', 'copper', 'cu']))
            }
          });
        }

        if (parsedFoods.length === 0) {
          throw new Error('Tidak ditemukan data makanan yang valid di dalam file Excel.');
        }

        resolve({ items: parsedFoods, errors });
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = (err) => reject(err);
    reader.readAsArrayBuffer(file);
  });
};


// ==========================================
// 2. PARENTERAL DATABASE HELPERS
// ==========================================

export const PARENTERAL_EXCEL_COLUMNS = [
  { key: 'name', label: 'Nama Produk Parenteral *' },
  { key: 'unit', label: 'Kemasan / Satuan *' },
  { key: 'energy_kcal', label: 'Energi Total (Kcal) *' },
  { key: 'protein_g', label: 'Asam Amino / Protein (g) *' },
  { key: 'carbohydrate_g', label: 'Karbohidrat / Dextrose (g) *' },
  { key: 'fat_g', label: 'Lipid / Lemak (g) *' },
  // Factors
  { key: 'carb_factor', label: 'Faktor Kalori KH (kcal/g)' },
  { key: 'fat_factor', label: 'Faktor Kalori Lemak (kcal/g)' },
  // Elektrolit (mmol)
  { key: 'sodium_mmol', label: 'Natrium (mmol)' },
  { key: 'potassium_mmol', label: 'Kalium (mmol)' },
  { key: 'calcium_mmol', label: 'Kalsium (mmol)' },
  { key: 'chloride_mmol', label: 'Klorida (mmol)' },
  { key: 'magnesium_mmol', label: 'Magnesium (mmol)' },
  { key: 'phosphate_mmol', label: 'Fosfat (mmol)' },
  // Parameter Lain
  { key: 'lactate_mmol', label: 'Laktat (mmol)' },
  { key: 'acetate_meq', label: 'Asetat (mEq)' },
  { key: 'nitrogen_g', label: 'Nitrogen (g)' },
  { key: 'osmolarity', label: 'Osmolaritas (mOsm/L)' },
  { key: 'mct', label: 'MCT (g)' },
  { key: 'omega3', label: 'Omega-3 (g)' }
];

/**
 * Export all parenteral products to Excel
 */
export const exportParenteralToExcel = (products, filename = 'NUTRIMUS_Database_Parenteral.xlsx') => {
  const headers = PARENTERAL_EXCEL_COLUMNS.map(c => c.label);

  const rows = products.map(item => {
    const macro = item.macronutrients || {};
    const factors = item.factors || {};
    const electro = item.electrolytes || {};
    const other = item.other || {};

    return [
      item.name || '',
      item.unit || '500ml',
      macro.energy_kcal !== undefined ? Math.round(macro.energy_kcal) : 0,
      macro.protein_g !== undefined ? Number(macro.protein_g) : 0,
      macro.carbohydrate_g !== undefined ? Number(macro.carbohydrate_g) : 0,
      macro.fat_g !== undefined ? Number(macro.fat_g) : 0,
      factors.carb_factor !== undefined ? Number(factors.carb_factor) : 3.4,
      factors.fat_factor !== undefined ? Number(factors.fat_factor) : 9.0,
      electro.sodium_mmol !== undefined ? Number(electro.sodium_mmol) : 0,
      electro.potassium_mmol !== undefined ? Number(electro.potassium_mmol) : 0,
      electro.calcium_mmol !== undefined ? Number(electro.calcium_mmol) : 0,
      electro.chloride_mmol !== undefined ? Number(electro.chloride_mmol) : 0,
      electro.magnesium_mmol !== undefined ? Number(electro.magnesium_mmol) : 0,
      electro.phosphate_mmol !== undefined ? Number(electro.phosphate_mmol) : 0,
      other.lactate_mmol !== undefined ? Number(other.lactate_mmol) : 0,
      other.acetate_meq !== undefined ? Number(other.acetate_meq) : 0,
      other.nitrogen_g !== undefined ? Number(other.nitrogen_g) : 0,
      other.osmolarity !== undefined ? Number(other.osmolarity) : 0,
      other.mct !== undefined ? Number(other.mct) : 0,
      other.omega3 !== undefined ? Number(other.omega3) : 0
    ];
  });

  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Database Parenteral');
  XLSX.writeFile(wb, filename);
};

/**
 * Generate and download Parenteral Template Excel
 */
export const downloadParenteralTemplateExcel = () => {
  const headers = PARENTERAL_EXCEL_COLUMNS.map(c => c.label);

  const sampleRows = [
    [
      'Aminofluid 500ml', '500ml', 210, 15.0, 37.5, 0.0,
      3.4, 9.0, 17.5, 10.0, 0.0, 17.5, 2.5, 5.0,
      0.0, 17.5, 2.4, 600, 0.0, 0.0
    ],
    [
      'SMOFlipid 20% 100ml', '100ml', 200, 0.0, 0.0, 20.0,
      3.4, 10.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.5,
      0.0, 0.0, 0.0, 380, 6.0, 0.6
    ]
  ];

  const ws = XLSX.utils.aoa_to_sheet([headers, ...sampleRows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Template Parenteral');
  XLSX.writeFile(wb, 'NUTRIMUS_Template_Import_Parenteral.xlsx');
};

/**
 * Parse uploaded Parenteral Excel file into backend ParenteralItemCreate payload
 */
export const parseParenteralExcel = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rawRows = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });

        if (!rawRows || rawRows.length < 2) {
          throw new Error('File Excel kosong atau tidak memiliki baris data.');
        }

        const headerRow = rawRows[0].map(h => String(h).trim().toLowerCase());

        const findColIdx = (keywords) => {
          return headerRow.findIndex(h => keywords.some(k => h.includes(k.toLowerCase())));
        };

        const nameIdx = findColIdx(['nama produk', 'nama', 'name']);
        const unitIdx = findColIdx(['kemasan', 'satuan', 'unit']);
        const energyIdx = findColIdx(['energi', 'energy', 'kcal']);
        const proteinIdx = findColIdx(['asam amino', 'protein']);
        const carbsIdx = findColIdx(['karbohidrat', 'dextrose', 'carbs', 'kh']);
        const fatIdx = findColIdx(['lipid', 'lemak', 'fat']);

        if (nameIdx === -1 || energyIdx === -1) {
          throw new Error('Kolom wajib "Nama Produk" dan "Energi (Kcal)" tidak ditemukan di header Excel.');
        }

        const getNum = (row, idx, defaultVal = 0) => {
          if (idx === -1 || row[idx] === undefined || row[idx] === '') return defaultVal;
          const val = Number(String(row[idx]).replace(',', '.').trim());
          return isNaN(val) ? defaultVal : val;
        };

        const parsedItems = [];

        for (let i = 1; i < rawRows.length; i++) {
          const row = rawRows[i];
          const name = String(row[nameIdx] || '').trim();
          if (!name) continue;

          const unit = unitIdx !== -1 && row[unitIdx] ? String(row[unitIdx]).trim() : '500ml';
          const energy = getNum(row, energyIdx);
          const protein = getNum(row, proteinIdx);
          const carbs = getNum(row, carbsIdx);
          const fat = getNum(row, fatIdx);

          parsedItems.push({
            name,
            unit,
            macronutrients: {
              energy_kcal: Math.round(energy),
              protein_g: Number(protein.toFixed(2)),
              carbohydrate_g: Number(carbs.toFixed(2)),
              fat_g: Number(fat.toFixed(2))
            },
            factors: {
              carb_factor: getNum(row, findColIdx(['faktor kalori kh', 'faktor kh', 'carb_factor']), 3.4),
              fat_factor: getNum(row, findColIdx(['faktor kalori lemak', 'faktor lemak', 'fat_factor']), 9.0)
            },
            electrolytes: {
              sodium_mmol: getNum(row, findColIdx(['natrium', 'sodium'])),
              potassium_mmol: getNum(row, findColIdx(['kalium', 'potassium'])),
              calcium_mmol: getNum(row, findColIdx(['kalsium', 'calcium'])),
              chloride_mmol: getNum(row, findColIdx(['klorida', 'chloride'])),
              magnesium_mmol: getNum(row, findColIdx(['magnesium'])),
              phosphate_mmol: getNum(row, findColIdx(['fosfat', 'phosphate']))
            },
            other: {
              lactate_mmol: getNum(row, findColIdx(['laktat', 'lactate'])),
              acetate_meq: getNum(row, findColIdx(['asetat', 'acetate'])),
              nitrogen_g: getNum(row, findColIdx(['nitrogen'])),
              osmolarity: getNum(row, findColIdx(['osmolaritas', 'osmolarity'])),
              mct: getNum(row, findColIdx(['mct'])),
              omega3: getNum(row, findColIdx(['omega-3', 'omega 3']))
            }
          });
        }

        if (parsedItems.length === 0) {
          throw new Error('Tidak ditemukan produk parenteral yang valid di dalam file Excel.');
        }

        resolve({ items: parsedItems });
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = (err) => reject(err);
    reader.readAsArrayBuffer(file);
  });
};
